import { FeedReducer } from '../../pages/Feed'

const rootReducer = { Feed: FeedReducer }

export default rootReducer